'use client';

import { Button } from '@/components/ui/button';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { TableCell, TableRow } from '@/components/ui/table';
import { Text } from '@/components/ui/text';
import { Upload } from 'lucide-react';

interface DataTableEmptyRowProps {
  columnLength: number;
  onClearFilters?: () => void;
  onUploadFiles?: () => void;
}

export function DataTableEmptyRow({
  columnLength,
  onClearFilters,
  onUploadFiles,
}: DataTableEmptyRowProps) {
  return (
    <TableRow>
      <TableCell colSpan={columnLength} className="h-24 text-center">
        <FlexCol gap="6" alignItems="center" justifyContent="center" p="6">
          <FlexCol gap="2">
            <Text variant="body-lg" color="primary">
              No documents found
            </Text>
            <Text variant="body-sm" color="secondary">
              Please try again with different filters or upload a document.
            </Text>
          </FlexCol>

          <FlexRow gap="2" alignItems="center" justifyContent="center">
            <Button variant="secondary" onClick={onClearFilters}>
              Clear search
            </Button>
            <Button onClick={onUploadFiles}>
              <Upload />
              Upload files
            </Button>
          </FlexRow>
        </FlexCol>
      </TableCell>
    </TableRow>
  );
}
